import {FC, useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import FormHeader from 'components/Form/FormHeader';
import Link from 'components/Link';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import Notification from 'components/Notification';
import useMessage from 'hooks/useMessage';
import {useBackend} from 'state/backend';
import {PdfFilenameSettingsBackendData} from '../types';
import Section from './Section';

const ViewPdfFilenameSettingsPage: FC = () => {
    const {t} = useTranslation('Document.PdfFilenameSettings');
    const {successMessage} = useMessage<'successMessage'>();
    const {
        data: {isUpgradeRequired},
    } = useBackend<PdfFilenameSettingsBackendData>();

    const [showNotification, setShowNotification] = useState(!!successMessage);

    return (
        <div>
            {showNotification && (
                <Notification
                    className="mb-4"
                    onClick={() => setShowNotification(false)}
                    type="success"
                >
                    {successMessage}
                </Notification>
            )}
            <NavigationTabs.DocumentSettings selection="pdfFilenameSettings" />
            <FormHeader
                link={{
                    disabled: isUpgradeRequired,
                    href: window.Urls.pdf_filename_settings_edit(),
                    icon: 'edit',
                    kind: 'secondary',
                    label: t('form:edit'),
                }}
                subtitle={
                    <Trans
                        components={[
                            <Link
                                key={0}
                                href="https://help.makeleaps.jp/ja/articles/8059992"
                                isOpenInNewTab={true}
                            >
                                {' '}
                            </Link>,
                        ]}
                        i18nKey="subTitle"
                        t={t}
                    />
                }
                title={t('title')}
            />
            {isUpgradeRequired && (
                <Notification className="mt-4" icon="warning" type="alert">
                    <Trans
                        components={[
                            <Link
                                key={0}
                                href="https://www.makeleaps.jp/pricing/"
                                isOpenInNewTab={true}
                            >
                                {' '}
                            </Link>,
                        ]}
                        i18nKey="message.upgradePlan"
                        t={t}
                    />
                </Notification>
            )}
            <Section sectionName="pdfFilenameEmployee" />
            <Section sectionName="pdfFilenameClient" />
        </div>
    );
};

export default ViewPdfFilenameSettingsPage;
